import React, { useEffect } from "react";
import { Form, Input, Modal } from "antd";

const AdmsCommandModal = ({ open, onCancel, onSubmit, loading, machine }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) {
      return;
    }

    form.setFieldsValue({ command: "INFO" });
  }, [open, form]);

  const handleFinish = (values) => {
    onSubmit({
      machine_id: machine?.id,
      command: values.command,
    });
  };

  return (
    <Modal
      open={ open }
      title="Queue ADMS Command"
      okText="Queue Command"
      onCancel={ onCancel }
      okButtonProps={ { loading } }
      onOk={ () => form.submit() }
      destroyOnClose
      width={ 640 }
    >
      <Form form={ form } layout="vertical" onFinish={ handleFinish }>
        <Form.Item
          name="command"
          label="Command"
          rules={ [{ required: true, message: "Command is required" }] }
        >
          <Input.TextArea rows={ 4 } placeholder="Example: DATA QUERY USERINFO PIN=ALL" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AdmsCommandModal;
